import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { SearchingEverywhereIllustration } from './SearchingEverywhere';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const SearchingEverywhere = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <SearchingEverywhereIllustration title={title} />
  </IllustrationWrapper>
);
